/* eslint-disable */
import { client } from './client';
import { appConfig } from '../config/app-config';
import { CancelToken } from 'axios';
import { AddNoteRequest, AddNoteResponse, SearchNotesRequest, FetchNotesResponse } from '../types/noteTypes';


const getSelectedStore = (): string => {
  return window.sessionStorage.getItem('storeNumber') || '';
};

export const addNote = async (
  customerId: string,
  noteText: string,
  noteType = 'STMT'
): Promise<AddNoteResponse | undefined> => {
  const storeNumber = getSelectedStore();

  const payload: AddNoteRequest = {
    customerId,
    note: noteText,
    customerNoteType: noteType,
    storeNumber,
  };

  return await client(
    'create',
    {
      method: 'POST',
      body: payload,
    },
    appConfig.apiUrls.customers,
    true
  );
};

export const searchNotes = async (
  customerId: string,
  searchQuery = '',
  limit = 20,
  offset = 0,
  cancelToken?: CancelToken
): Promise<FetchNotesResponse | undefined> => {
  const storeNumber = getSelectedStore();

  const payload: SearchNotesRequest = {
    customerId,
    customerNoteType: 'STMT',
    storeNumber,
    searchParam: searchQuery,
    limit,
    offset,
  };
  
  return await client(
    'searchnotes',
    {
      method: 'POST',
      body: payload,
      cancelToken,
    },
    appConfig.apiUrls.customers,
    true
  );
};


export const updateNote = async (
  customerId: string,
  note: string,
  customerNotesId: string
): Promise<any> => {
  const payload = {
    customerId,
    note,
    customerNotesId,
  };

  return await client(
    'updatenote',
    {
      method: 'POST',
      body: payload,
    },
    appConfig.apiUrls.customers,
    true
  );
};

export const removeNote = async (
  customerId: string,
  customerNotesId: string
): Promise<any> => {
  const payload = {
    customerId,
    customerNotesId,
  };

  return await client(
    'removenote',
    {
      method: 'POST',
      body: payload,
    },
    appConfig.apiUrls.customers,
    true
  );
};

export const getNoteDetails = async (
  customerNoteId: string,
  cancelToken?: CancelToken
): Promise<any> => {
  return await client(
    `getnote/${customerNoteId}`,
    {
      method: 'GET',
      cancelToken,
    },
    appConfig.apiUrls.customers,
    true
  );
};